import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StatisticsComponent } from './pages/statistics/statistics.component';
import { MenuComponent } from './components/menu/menu.component';
import { InstallationsListComponent } from './pages/installations/installations-list/installations-list.component';
import { CallsListComponent } from './pages/calls/calls-list/calls-list.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { InstallationComponent } from './pages/installation/installation/installation.component';
import { CompaniesListComponent } from './pages/companies-list/companies-list.component';
import { PeopleListComponent } from './pages/people-list/people-list.component';
import { PersonComponent } from './pages/person/person.component';
import { StockManagerComponent } from './pages/stock-manager/stock-manager.component';
import { HomeComponent } from './pages/home/home.component';
import { IncidentsListComponent } from './pages/incidents/incidents-list/incidents-list.component';
import { SeriesListComponent } from './pages/series-list/series-list.component';
import { ToolsComponent } from './pages/tools/tools.component';
import { WikiComponent } from './pages/wiki/wiki.component';
import { MessagesListComponent } from './pages/messages-list/messages-list.component';
import { FooterComponent } from './components/footer/footer.component';
import { CompanyComponent } from './pages/company/company.component';
import { MachineComponent } from './pages/machine/machine/machine.component';
import { CallComponent } from './pages/calls/call/call.component';
import { MessageComponent } from './pages/message/message.component';
import { SearchResultsComponent } from './pages/search-results/search-results.component';
import { MaterielComponent } from './pages/materiel/materiel.component';

// CHILDREN
import { InstallationsProjectsComponent } from './pages/installations/installations-projects/installations-projects.component';
import { InstallationsInstalledComponent } from './pages/installations/installations-installed/installations-installed.component';
import { InstallationsServiceComponent } from './pages/installations/installations-service/installations-service.component';
import { InstallationsStoppedComponent } from './pages/installations/installations-stopped/installations-stopped.component';
import { InstallationsUninstalledComponent } from './pages/installations/installations-uninstalled/installations-uninstalled.component';
import { InstallationsCustomComponent } from './pages/installations/installations-custom/installations-custom.component';

import { InstallationPropertiesComponent } from './pages/installation/installation-properties/installation-properties.component';
import { InstallationConnectionsComponent } from './pages/installation/installation-connections/installation-connections.component';
import { InstallationSalesComponent } from './pages/installation/installation-sales/installation-sales.component';
import { InstallationStatisticsComponent } from './pages/installation/installation-statistics/installation-statistics.component';
import { InstallationIncidentsComponent } from './pages/installation/installation-incidents/installation-incidents.component';
import { InstallationInterventionsComponent } from './pages/installation/installation-interventions/installation-interventions.component';
import { InstallationPhotosComponent } from './pages/installation/installation-photos/installation-photos.component';
import { InstallationMiscellaneousComponent } from './pages/installation/installation-miscellaneous/installation-miscellaneous.component';
import { InstallationHourlyDistributionComponent } from './pages/installation/installation-statistics/installation-hourly-distribution/installation-hourly-distribution.component';
import { InstallationMonthlyEvolutionComponent } from './pages/installation/installation-statistics/installation-monthly-evolution/installation-monthly-evolution.component';
import { InstallationPaymentMethodComponent } from './pages/installation/installation-statistics/installation-payment-method/installation-payment-method.component';
import { InstallationWeeklyDistributionComponent } from './pages/installation/installation-statistics/installation-weekly-distribution/installation-weekly-distribution.component';

import { InstallationIncidentsListComponent } from './pages/installation/installation-incidents-list/installation-incidents-list.component';
import { InstallationErrorReportsComponent } from './pages/installation/installation-error-reports/installation-error-reports.component';

import { MachinePropertiesComponent } from './pages/machine/machine-properties/machine-properties.component';
import { MachineEquipmentComponent } from './pages/machine/machine-equipment/machine-equipment.component';
import { MachineHistoricComponent } from './pages/machine/machine-historic/machine-historic.component';
import { LoginComponent } from './pages/login/login.component';
import { IncidentsComponent } from './pages/incidents/incidents/incidents.component';
import { IncidentsPannesComponent } from './pages/incidents-pannes/incidents-pannes.component';
import { AdminComponent } from './pages/admin/admin.component';
import { ChangelogsComponent } from './pages/changelogs/changelogs.component';
import { CallsComponent } from './pages/calls/calls/calls.component';
import { HomeWarningComponent } from './pages/home/home-warning/home-warning.component';


const routes: Routes = [
  { path: 'statistics', component: StatisticsComponent, data:{title:'Statistiques'} },
  { path: 'menu', component: MenuComponent },
  {
    path: 'installations-list', component: InstallationsListComponent, data:{title:'Installations'},
    children: [
      {
        path: 'Installations-projects', component: InstallationsProjectsComponent, data:{title:'Projets d\'installation'},
      },
      {
        path: 'Installations-installed', component: InstallationsInstalledComponent, data:{title:'Machines installées'},
      },
      {
        path: 'Installations-service', component: InstallationsServiceComponent, data:{title:'Installations en service'},
      },
      {
        path: 'Installations-stopped', component: InstallationsStoppedComponent, data:{title:'Installations arrêtées'},
      },
      {
        path: 'Installations-uninstalled', component: InstallationsUninstalledComponent, data:{title:'Machines désinstallées'},
      },
      {
        path: 'Installations-custom', component: InstallationsCustomComponent, data:{title:'Installations - Personnaliser'},
      },
      // {
      //   path: '', redirectTo: 'Installations-service', pathMatch: 'full',
      // }
    ]
  },
  { path: 'calls', component: CallsComponent, data:{title:'Appels'} },
  { path: 'search-bar', component: SearchBarComponent },
  {
    path: 'installation/:id', component: InstallationComponent, data:{title:'Installation'},
    children: [
      { path: 'installation-properties', component: InstallationPropertiesComponent, data:{title:'Installation - Propriétés'} },
      { path: 'installation-connections', component: InstallationConnectionsComponent, data:{title:'Installation - Connexions'} },
      { path: 'installation-sales', component: InstallationSalesComponent, data:{title:'Installation - Ventes'} },
      { path: 'installation-statistics', component: InstallationStatisticsComponent, data:{title:'Installation - Statistiques'},
      children: [
        {path: 'installation-hourly-distribution', component: InstallationHourlyDistributionComponent},
        {path: 'installation-monthly-evolution', component: InstallationMonthlyEvolutionComponent},
        {path: 'installation-payment-method', component: InstallationPaymentMethodComponent},
        {path: 'installation-weekly-distribution', component: InstallationWeeklyDistributionComponent}
      ] 
    
    },
      {
        path: 'installation-incidents', component: InstallationIncidentsComponent, data:{title:'Installation - Incidents'},
        children: [
          { path: 'installation-incidents-list', component: InstallationIncidentsListComponent },
          { path: 'installation-error-reports', component: InstallationErrorReportsComponent },
          { path: '', redirectTo: 'installation-incidents-list', pathMatch: 'full' }
        ]
      },
      { path: 'installation-interventions', component: InstallationInterventionsComponent, data:{title:'Installation - Interventions'} },
      { path: 'installation-photos', component: InstallationPhotosComponent, data:{title:'Installation - Photos'} },
      { path: 'installation-miscellaneous', component: InstallationMiscellaneousComponent, data:{title:'Installation - Divers'} },
      // { path: '', redirectTo: 'installation-connections', pathMatch: 'full' }
    ]
  },
  { path: 'companies-list', component: CompaniesListComponent, data:{title:'Sociétés'} },
  { path: 'people-list', component: PeopleListComponent, data:{title:'Personnes'} },
  { path: 'person', component: PersonComponent, data:{title:'Personne'} },
  { path: 'stock-manager', component: StockManagerComponent, data:{title:'Gestion du stock'} },
  { 
    path: 'home', component: HomeComponent, data:{title:'Accueil', showitem: true},
    children: [
      { path: 'warning', component:HomeWarningComponent}
    ] 
  },
  { path: 'incidents-list', component: IncidentsListComponent, data:{title:'Incidents'} },
  { path: 'incidents', component: IncidentsComponent },
  { path: 'incidents-pannes/:id', component: IncidentsPannesComponent },



  { path: 'series-list', component: SeriesListComponent, data:{title:'Séries de distributeurs'} },
  { path: 'tools', component: ToolsComponent, data:{title:'Outils'} },
  { path: 'wiki', component: WikiComponent, data:{title:'Wiki'} },
  { path: 'messages-list', component: MessagesListComponent, data:{title:'Messages'} },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'footer', component: FooterComponent },
  { path: 'company', component: CompanyComponent, data:{title:'Société'} },
  {
    path: 'machine/:id', component: MachineComponent, data:{title:'Machine'},
    children: [
      { path: 'machine-properties', component: MachinePropertiesComponent },
      { path: 'machine-equipment', component: MachineEquipmentComponent },
      { path: 'machine-historic', component: MachineHistoricComponent },
      { path: '', redirectTo: 'machine-properties', pathMatch: 'full' }
    ]
  },
  { path: 'call/:id', component:CallComponent, data:{title:'Intervention'}},
  { path: 'message/:id', component:MessageComponent, data:{title:'Message'}},
  { path: 'login', component: LoginComponent},
  { path: 'admin', component: AdminComponent},
  { path:'changelogs', component: ChangelogsComponent },
  { path: 'search-results/:searchdata', component:SearchResultsComponent, data:{title:'Résultat de recherche'}},
  { path: 'materiel/:id',component:MaterielComponent, data:{title:'Matériel'}}


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
